import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { CpAgGridService } from '@app/Modules/cp-grid/services/cp-ag-grid-service';
import { CbService } from '@app/Modules/chargeback/Services/cb.service';

@Component({
  selector: 'app-contextmenu-manage-error',
  templateUrl: './contextmenu-manage-error.component.html',
  styleUrls: ['./contextmenu-manage-error.component.scss']
})

export class ContextmenuManageErrorComponent implements AgRendererComponent, OnInit {

  params: any;
  ellipseSelect: boolean = false;
  
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cpAgGridService: CpAgGridService,
    private cbServ: CbService
  ) { }

  agInit(params: any) {
    this.params = params;
  }

  ngOnInit(){
    this.cbServ.implementRowDelete().subscribe(data => {
      if (data) {
        // this.params.api.updateRowData({ remove: [this.params.node.data] });
      }
    });
  }

  refresh(params: any): boolean {
    return true;
  }

  contextmenuToggle(element, e){
    element.toggle(e);
  }

  onContextMenuHide(){
    this.ellipseSelect = false;
  }

  onContextMenuShow(){
    this.ellipseSelect = true;
  }

  editLine(e, element){
    // let rawErrorData = Object.assign({}, this.cpAgGridService.getEFileErrorData(), {"currentErrorLine": this.params.data.line});
    let fileDetails = this.cpAgGridService.getEFileErrorData().fileDetails;
    let errorDataArray = this.cpAgGridService.getEFileErrorData().errorData;
    errorDataArray = errorDataArray.filter(item => {
      return !item.isDeleted;
    });
    let Obj = {
      "errorData": errorDataArray,
      "fileDetails": fileDetails
    }
    let rawErrorData = Object.assign({}, Obj, {"currentErrorLine": this.params.data.line});
    element.hide(e);
    this.router.navigate([{ outlets: { editModalDialog: ['editModal'] } }], { relativeTo: this.activatedRoute, queryParamsHandling: "preserve", state: {'fileErrorData': rawErrorData} });
  }
  deleteLine(e, element) {
    let payload = this.cbServ.getDeleteOrDownloadPayload();//this gets claimefileID and salesorgid for delete error line and download error file on correct error page
    let line = this.params.data.line;
    let request = {
      "claimFileId": payload.request.query.claimFileId,
      "lineNumber": line,
      "salesOrgId": payload.request.query.salesOrgId
    }
    element.hide(e);
    this.router.navigate([{ outlets: { deleteErrorLineConfirmation: ['deleteErrorLineConfirmation'] } }], { relativeTo: this.activatedRoute, skipLocationChange: true, state: {'request': request}, queryParamsHandling: "preserve" });
  }
}
